// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import xOrderInformationStyles from "@conklin/App/SharedStyles/MyAccountPages/Details/OrderInformationStyles";
import { savedOrderDetailsOrderInformationStyles } from "@conklin/Overrides/Widgets/SavedOrderDetails/SavedOrderDetailsOrderInformation";
import { color, xScreen } from "@conklin/XDL/Utilities";
import { css } from "styled-components";

savedOrderDetailsOrderInformationStyles.orderDateTitle = {
    variant: "h6",
    css: css`
        @media print {
            font-size: 12px;
        }
        margin-bottom: 8px;
    `,
};
savedOrderDetailsOrderInformationStyles.orderDateText = {
    size: 14,
    lineHeight: "17px",
};
savedOrderDetailsOrderInformationStyles.shippingAddressTitle = {
    ...xOrderInformationStyles.address?.informationTitle,
};
savedOrderDetailsOrderInformationStyles.billingAddressTitle = {
    ...xOrderInformationStyles.address?.informationTitle,
};
savedOrderDetailsOrderInformationStyles.mainInformationGridItem = {
    width: 12,
    css: css`
        &&& {
            flex-direction: column;
            padding-bottom: 0;
        }
    `,
};
savedOrderDetailsOrderInformationStyles.billingInformationGridItem = {
    width: [12, 12, 12, 6, 6],
    css: css`
        flex-direction: column;
        padding-top: 0;
        order: 1;
    `,
};

savedOrderDetailsOrderInformationStyles.shippingInformationGridItem = {
    width: [12, 12, 12, 6, 6],
    css: css`
        flex-direction: column;
        order: 2;
    `,
};

savedOrderDetailsOrderInformationStyles.orderInformationGridContainer = {
    gap: 12,
    css: css`
        padding-bottom: 24px;
        border-bottom: 1px solid ${color("common.border")};
        ${xScreen("lte", "md")} {
            padding-bottom: 0;
            border: none;
        }
    `,
};

savedOrderDetailsOrderInformationStyles.addressesTitle = {
    ...xOrderInformationStyles.address?.heading,
};

savedOrderDetailsOrderInformationStyles.addressesGridItem = {
    width: 12,
    css: css`
        padding-top: 0;
        padding-bottom: 0;
    `,
};
